// extracted by mini-css-extract-plugin
export default {"StatusBar":"styles_StatusBar__hbUoD","StatusBarRight":"styles_StatusBarRight__uPj8h"};